import { type SxProps, type Theme } from '@mui/material'

export const formBoxStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  // p: 2,
  // border: theme => `1px solid ${theme.vars.palette.divider}`,
  // borderRadius: 1.5,
}
